// extracted by mini-css-extract-plugin
export var content = "_no-1";
export var fullScreen = "_no-0";